import { compact, toUpper } from 'lodash';
import { selection, timePeriods, raceTypes } from '../../utils/filter';
import { formatDate } from '../../utils/date';

const getExtraTimeOptions = (hasCurrentYear, currentYear, seasons, type) => {
    const firstSeasonStart = 1988;
    const lastSeasonEnd = +formatDate(
        seasons[0].seasonEndDate, 'YYYY'
    );

    const allOption = timePeriods.getAll(firstSeasonStart, currentYear);
    const currentYearOption = timePeriods.getCurrent(currentYear, type);
    currentYearOption.selected = true;
    const last5Option = timePeriods.getLast5(currentYear, type);

    const hasFewSeasons = seasons.length > 1;
    const hasLast5Seasons = currentYear - lastSeasonEnd < 5;

    return compact([
        hasFewSeasons && allOption,
        hasCurrentYear && currentYearOption,
        hasLast5Seasons && last5Option,
    ]);
};

const getAvailableTimeOptions = (seasonsAvailable, raceType) => {
    const options = timePeriods.getAvailable(seasonsAvailable, toUpper(raceType));
    options[0].selected = true;
    return options;
};

export const timePeriodsFactory = (country, raceType, seasonsAvailable) => {
    const seasons = seasonsAvailable[toUpper(raceType)];

    const currentYear = timePeriods.getCurrentSeasonEndYear(raceType, country);

    const hasCurrentYear = seasons[0].seasonDesc.includes(currentYear);

    const availableSeasonsOptions = getAvailableTimeOptions(seasonsAvailable, raceType);
    const extraOptions = getExtraTimeOptions(hasCurrentYear, currentYear, seasons, raceType);

    const options = [
        ...extraOptions,
        ...hasCurrentYear ? availableSeasonsOptions.slice(1) : availableSeasonsOptions,
    ];

    const timePeriod = {
        title: 'time period',
        options,
        createdBy: {
            raceType,
            seasonsAvailable,
            country,
        },
    };

    return timePeriod;
};

export function raceTypesFactory(typeCode, raceType, seasonsAvailable) {
    const options = raceTypes.getForCourse(typeCode, seasonsAvailable, true);

    return {
        title: 'race type',
        options: selection.setSelected(options, raceType),
    };
}

export const categoriesFactory = (typeCode, country, raceType, seasonsAvailable) => (
    seasonsAvailable ? {
        raceType: raceTypesFactory(typeCode, raceType, seasonsAvailable),
        timePeriod: timePeriodsFactory(country, raceType, seasonsAvailable),
    } : null
);



// WEBPACK FOOTER //
// ./src/js/course/stats/categories.js